export default "__VITE_ASSET__3c95f46f__"